import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";

const StyledGalleryResultSkeleton = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    borderRadius: theme.kaltura.shape.roundness1,
    height: theme.spacing(4),
}));

const StyledGalleryResult = styled("div")(({ theme }) => ({
    width: "100%",
    marginRight: theme.spacing(2),
    ":last-child": {
        marginRight: 0,
    },
}));

const GalleryResult = () => {
    return (
        <StyledGalleryResult>
            <StyledGalleryResultSkeleton variant="rectangular" />
            <StyledGalleryResultSkeleton variant="rectangular" />
        </StyledGalleryResult>
    );
};

const StyledGalleryResultsSkeleton = styled("div")({
    display: "flex",
    justifyContent: "space-between",
});

/**
 * global search results skeleton - gallery results
 */
export const GalleryResultsSkeleton = () => {
    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.up("sm"));
    const md = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <StyledGalleryResultsSkeleton>
            <GalleryResult />
            {sm && <GalleryResult />}
            {md && <GalleryResult />}
        </StyledGalleryResultsSkeleton>
    );
};
